<div class="flex flex-col">
  <div *ngIf="!managingBuilding" class="md:mt-2">
    <div class="gap-5 flex justify-between portal-actions">
      <button type="button" *ngIf="!managingBuilding && canEdit"
        mat-button color="primary" (click)="createBuilding()">Add a building</button>
      <button type="button" *ngIf="!managingBuilding"
        mat-button color="primary" class="ml-auto" (click)="getBuildings(!includeArchived)">
        {{includeArchived ? 'Hide Archived' : 'Show Archived'}}
      </button>
    </div>

      <mat-table [dataSource]="onCampusBuildingSource" matSort #onCampusBuildingSort="matSort" aria-describedby="On-Campus Buildings" class="mat-elevation-z8 portal-responsive-table">
        <ng-container matColumnDef="buildingId">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Building ID</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let building">
          <span class="mobile-label">Building ID</span>
          {{ HospitalLicenseId }}-{{ building.buildingId }}
        </mat-cell>
      </ng-container>

        <ng-container matColumnDef="buildingName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">Building Name</mat-header-cell>
          <mat-cell tabindex="0" *matCellDef="let building">
            <span class="mobile-label">Building Name</span>
            {{ building.buildingName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="archived">
          <mat-header-cell *matHeaderCellDef mat-sort-header=""></mat-header-cell>
          <mat-cell tabindex="0" *matCellDef="let building">
            <span class="font-semibold" *ngIf="building.archived">Archived</span>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="onCampusBuildingColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: onCampusBuildingColumns" class=""
                 [ngClass]="row.archived? 'portal-archived' : ''" (click)="selectBuilding(row)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectBuilding(row))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectBuilding(row))"></mat-row>
      </mat-table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" #onCampusBuildingPaginator="matPaginator">
      </mat-paginator>
  </div>

  <div class="flex flex-col w-full" *ngIf="managingBuilding" [@slideRight]>
    <form [formGroup]="buildingForm" class="flex flex-col w-full gap-y-8">
      <div class="flex flex-row gap-2 portal-section-grid">
        <div class="flex flex-col w-1/2 gap-2">
          <div flex flex-row>
            <div class="flex justify-between items-center gap-4 w-full">
              <div class="flex items-center gap-2 portal-actions">
                <span class="font-semibold" *ngIf="managingBuilding && !newBuildingCreated">Managing Building</span>
                <span class="font-semibold" *ngIf="managingBuilding && newBuildingCreated">Add a Building</span>
                <button type="button" *ngIf="managingBuilding && buildingForm.valid && canEdit"
                        mat-button color="primary" (click)="saveBuilding()">Save</button>
                <button type="button" *ngIf="managingBuilding && canEdit"
                        mat-button color="warn" (click)="toggleBuildingForm(false)">Close</button>
                        <button type="button" *ngIf="!canEdit"
                        mat-button color="warn" (click)="toggleBuildingForm(false)">Close</button>
              </div>
              <div class="flex items-center gap-2 portal-actions">
                <button type="button" mat-button color="warn" *ngIf="canEdit"
                        (click)="confirmDelete(onCampusBuilding.id)">Delete</button>
                <button type="button" mat-icon-button *ngIf="canEdit"
                        [color]="onCampusBuilding.archived ? 'primary' : 'warn'"
                        (click)="archiveBuilding(onCampusBuilding, !onCampusBuilding.archived)"
                        [matTooltip]="onCampusBuilding.archived ? 'Un-Archive Building' : 'Archive Building'"
                        matTooltipShowDelay="500" matTooltipHideDelay="200">
                  <mat-icon [fontIcon]="onCampusBuilding.archived ? 'unarchive' : 'archive'"></mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="!canEdit" class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
            <div class="flex flex-row gap-2 md:w-1/3 portal-detail-row">
              <span class="font-semibold">Building ID:</span>
              <span>{{HospitalLicenseId}}-{{onCampusBuilding.buildingId}}</span>
            </div>

            <div class="flex flex-row gap-2 md:w-2/3 portal-detail-row">
              <span class="font-semibold">Name of the bulding:</span>
              <span>{{onCampusBuilding.buildingName}}</span>
            </div>
          </div>

          <div *ngIf="canEdit" class="flex flex-col md:flex-row md:gap-4 portal-field-grid location-primary-fields">
            <div class="location-id-field">
              <span class="location-id-prefix">{{HospitalLicenseId}}-</span>
              <mat-form-field class="flex-1">
                <mat-label>Building ID</mat-label>
                <input matInput formControlName="buildingId" [readonly]="!canEdit">
                <mat-error *ngIf="buildingForm.get('buildingId')?.hasError('required')">
                  A building ID is required
                </mat-error>
              </mat-form-field>
            </div>

            <mat-form-field class="md:w-2/3">
              <mat-label>Name of the building</mat-label>
              <input matInput formControlName="buildingName">
              <mat-error *ngIf="buildingForm.get('buildingName')?.hasError('required')">
                A building name is required
              </mat-error>
            </mat-form-field>
          </div>

          <app-hospital-service-location
            [entityId]="onCampusBuilding.id"
            [entityType]="entity"
            [showType]="false"
            [canEdit]="canEdit">
          </app-hospital-service-location>
        </div>
        <div class="flex flex-col w-1/2 gap-4">
          <address [entityId]="onCampusBuilding.id"
            [entityType]="sharedService.onCampusBuilding"
            [limitEntries]="true"
            [isEditable]="canEdit"
            >
          </address>
          <div class="flex flex-col w-full gap-4">
            <span class="font-semibold">Documents:</span>
            <document
              [entityId]="onCampusBuilding.id"
              [entityType]="sharedService.onCampusBuilding"
              [editable]="canEdit"
              [types]="onCampusBuildingTypes">
            </document>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
